import { COACHINGSESSIONS_SERVICE } from "@/services/coachingSessions.service.js";

const state = {postCoachingSessionOutput: false, getCoachingSessionsOutput: {}, putCoachingSessionNoteOutput: false, putCoachingSessionOutput: false, putCoachingSessionStatusOutput: false, getCoachingSessionByIdOutput: {}, deleteCoachingSessionByIdOutput: {}};

const actions = {
    //Service to create coachingSessions
    postCoachingSession({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postCoachingSessionRequest');

        COACHINGSESSIONS_SERVICE.postCoachingSession(input)
            .then(
                output => {
                    commit('postCoachingSessionSuccess', output);
                },
                error => {
                    commit('postCoachingSessionFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get coachingSessions by status
    getCoachingSessions({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getCoachingSessionsRequest');

        COACHINGSESSIONS_SERVICE.getCoachingSessions(queryParams)
            .then(
                output => {
                    commit('getCoachingSessionsSuccess', output);
                },
                error => {
                    commit('getCoachingSessionsFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to update coachingSessionNotes
    putCoachingSessionNote({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putCoachingSessionNoteRequest');

        COACHINGSESSIONS_SERVICE.putCoachingSessionNote(input)
            .then(
                output => {
                    commit('putCoachingSessionNoteSuccess', output);
                },
                error => {
                    commit('putCoachingSessionNoteFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to update coaching session
    putCoachingSession({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putCoachingSessionRequest');

        COACHINGSESSIONS_SERVICE.putCoachingSession(input)
            .then(
                output => {
                    commit('putCoachingSessionSuccess', output);
                },
                error => {
                    commit('putCoachingSessionFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to change coaching session status
    putCoachingSessionStatus({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('putCoachingSessionStatusRequest');

        COACHINGSESSIONS_SERVICE.putCoachingSessionStatus(id)
            .then(
                output => {
                    commit('putCoachingSessionStatusSuccess', output);
                },
                error => {
                    commit('putCoachingSessionStatusFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get coachingSession details
    getCoachingSessionById({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getCoachingSessionByIdRequest');

        COACHINGSESSIONS_SERVICE.getCoachingSessionById(queryParams)
            .then(
                output => {
                    commit('getCoachingSessionByIdSuccess', output);
                },
                error => {
                    commit('getCoachingSessionByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to delete coachingSessions
    deleteCoachingSessionById({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('deleteCoachingSessionByIdRequest');

        COACHINGSESSIONS_SERVICE.deleteCoachingSessionById(queryParams)
            .then(
                output => {
                    commit('deleteCoachingSessionByIdSuccess', output);
                },
                error => {
                    commit('deleteCoachingSessionByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //postCoachingSession
    postCoachingSessionRequest(state) {
        state.postCoachingSessionOutput = null;
    },
    postCoachingSessionSuccess(state, output) {
        state.postCoachingSessionOutput = true;
    },
    postCoachingSessionFailure(state) {
        state.postCoachingSessionOutput = false;
    },

    //getCoachingSessions
    getCoachingSessionsRequest(state) {
    },
    getCoachingSessionsSuccess(state, output) {
        state.getCoachingSessionsOutput = output;
    },
    getCoachingSessionsFailure(state) {
        state.getCoachingSessionsOutput = false;
    },

    //putCoachingSessionNote
    putCoachingSessionNoteRequest(state) {
        state.putCoachingSessionNoteOutput = null;
    },
    putCoachingSessionNoteSuccess(state, output) {
        state.putCoachingSessionNoteOutput = true;
    },
    putCoachingSessionNoteFailure(state) {
        state.putCoachingSessionNoteOutput = false;
    },

    //putCoachingSession
    putCoachingSessionRequest(state) {
        state.putCoachingSessionOutput = null;
    },
    putCoachingSessionSuccess(state, output) {
        state.putCoachingSessionOutput = true;
    },
    putCoachingSessionFailure(state) {
        state.putCoachingSessionOutput = false;
    },

    //putCoachingSessionStatus
    putCoachingSessionStatusRequest(state) {
        state.putCoachingSessionStatusOutput = null;
    },
    putCoachingSessionStatusSuccess(state, output) {
        state.putCoachingSessionStatusOutput = true;
    },
    putCoachingSessionStatusFailure(state) {
        state.putCoachingSessionStatusOutput = false;
    },

    //getCoachingSessionById
    getCoachingSessionByIdRequest(state) {
    },
    getCoachingSessionByIdSuccess(state, output) {
        state.getCoachingSessionByIdOutput = output;
    },
    getCoachingSessionByIdFailure(state) {
        state.getCoachingSessionByIdOutput = false;
    },

    //deleteCoachingSessionById
    deleteCoachingSessionByIdRequest(state) {
        state.deleteCoachingSessionByIdOutput = null;
    },
    deleteCoachingSessionByIdSuccess(state, output) {
        state.deleteCoachingSessionByIdOutput = true;
    },
    deleteCoachingSessionByIdFailure(state) {
        state.deleteCoachingSessionByIdOutput = false;
    },
};

export const coachingSessions = {
    namespaced: true,
    state,
    actions,
    mutations
};